export function canvasDefinitionURL(definitionId: string): string {
  return `/canvases/${definitionId}`;
}

export function canvasVersionURL(definitionId: string, versionId: string): string {
  return `/canvases/${definitionId}/v/${versionId}`;
}
